import util from '@/libs/util.js'
import $ from 'jquery'

export default {
    methods: {
        handleMenuSelect(index, indexPath) {
            // 解决重复打开当前路径的问题（NavigationDuplicated问题）
            if (this.$route.path === this.$router.resolve({ path: index }).route.path) {
                return
            }
            /*
            打开方式：
            blank 打开新网页
            dialog 弹出框打开
            tab tab页方式打开
            self 自身页面跳转
            _self 直接刷新当前窗口
            */
            let openMode = $('.el-menu .el-menu-item[path="' + index.replace(/"/g, "&quot;") + '"]').attr('open-mode')
            console.log('打开模式：', openMode, index)
            if (/^d2-menu-empty-\d+$/.test(index)) {
                this.$message.warning('临时菜单')
            } else if (openMode === 'blank') {
                util.open(index, '_blank')
            } else if (openMode === '_self') {
                util.open(index, '_self')
            } else {
                this.$router.push({
                    path: index
                })
            }
            /*else if (/^https:\/\/|http:\/\//.test(index)) {
                util.open(index,'_blank')
            }*/
        }
    }
}
